export default __webpack_public_path__ + "static/media/Symbola.efe16799.ttf";